import { render, staticRenderFns } from "./SecurityBilling.vue?vue&type=template&id=6b7a95bb&lang=pug&"
import script from "./SecurityBilling.vue?vue&type=script&lang=js&"
export * from "./SecurityBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports